import types from './actionTypes';

const initialState = {
  loading: false,
  acquisitionOrders: [],
  error: '',
};

const acquisitionOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_ACQUISITION_ORDER_STATE:
      return initialState;
    case types.CREATE_ACQUISITION_ORDER.REQUEST:
    case types.UPDATE_ACQUISITION_ORDER.REQUEST:
    case types.SYNC_ACQUISITION_ORDERS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_ACQUISITION_ORDER.SUCCESS:
    case types.UPDATE_ACQUISITION_ORDER.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.SYNC_ACQUISITION_ORDERS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        acquisitionOrders: [...action.acquisitionOrders],
      };
    case types.CREATE_ACQUISITION_ORDER.FAILURE:
    case types.UPDATE_ACQUISITION_ORDER.FAILURE:
    case types.SYNC_ACQUISITION_ORDERS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default acquisitionOrderReducer;
